import AdvisorLoginForm from "../components/AdvisorLoginForm/AdvisorLoginForm";
import Card from "../components/Card/Card";
import styled from "styled-components";
import TimeLine from "../components/Timeline/Timeline";
import HeaderWithLogo from "../components/HeaderWithLogo";
import GeneralFooter from "../components/GeneralFooter/GeneralFooter";

const BodyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-image: url("sm-space.jpg");
  background-repeat: no-repeat, repeat;
  background-size: cover;
  position: relative;
  padding-bottom: 220px;

  @media (max-width: 480px) {
    padding-bottom: 400px;
  }

  .container {
    display: flex;
    //padding-bottom: 50px;
  }

  .column {
    width: 90%;
    margin: 0 auto;
    justify-content: space-between;
  }

  .formSection {
    margin-top: 5%;
  }

  @media (max-width: 850px) {
    .container {
      display: flex;
      flex-direction: column-reverse;
    }
    .column {
      justify-content: center;
    }
  }
`;

const AdvisorLogin = () => {
  return (
    <>
      <HeaderWithLogo isHelpButtonVisible={false} />
      <BodyWrapper>
        <div className="container" style={{ paddingBottom: "50px" }}>
          <div className="column">
            <TimeLine />
          </div>
          <div className="column" style={{ marginTop: "35px" }}>
            <div className="formSection">
              <Card>{<AdvisorLoginForm />}</Card>
            </div>
          </div>
        </div>
      </BodyWrapper>
      <GeneralFooter isFromAdvisorLogin={true} />
    </>
  );
};

export default AdvisorLogin;
